import React, { useEffect, useState } from "react";
import { Divider, Modal, Spin, Switch } from "antd";
import {
  DC_REPLENISHMENT_EXCEL_COLUMN,
  REPLENISHMENT_DATA_TYPE,
} from "../../util/columns";
import { useDispatch, useSelector } from "react-redux";
import { fetchReplenishmentList, MODULE_KEY } from "./action";
import TableFilter from "../common/TableFilter/TableFilter";
import Label from "../common/Label/Label";
import {
  replenishmentApprove,
  replenishmentRefresh,
  updateOrderQty,
} from "./saga";
import Breadcrumb from "../common/Breadcrumb/Breadcrumb";
import {
  showErrorNotification,
  showSuccessNotification,
} from "../../util/notifications";
import Button from "../common/Button/Button";
import filterColumns from "./filterColumns";
import VendorReplenishment from "./VendorReplenishment";
import { DownloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import styled from "styled-components";
import { getUserName } from "../common/UserDetails";
import useRolePermission from "src/hooks/useRolePermission";
import GenericGrid from "../common/Grid/GenericGrid";
import { MRT_RowSelectionState } from "material-react-table";
import { formatDate } from "src/util/date";
import { ACTION } from "src/util/utils";
const ExcelJS = require("exceljs");

function Replenishment() {
  const userName = getUserName();
  const [isPendingApprovalOnly, setIsPendingApprovalOnly] = useState(true);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState<REPLENISHMENT_DATA_TYPE[]>([]);
  const [approveModal, setApproveModal] = useState(false);
  const [rejectModal, setRejectModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [vendorName, setVendorName] = useState([]);
  const [sameVendorName, setSameVendorName] = useState([]);
  const [sameVendor, setSameVendor] = useState(false);
  const [exportFile, setExportFile] = useState(false);
  const [filteredData, setFilteredData] = useState<any>([]);
  const [pOSum, setPOSum] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [updateData, setupdateData] = useState<any>([]);

  const { hasPermission } = useRolePermission();
  let filterValues = filterColumns();
  const closeModal = (e: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(true);
  };
  const triggerModal = (e: React.MouseEvent<HTMLButtonElement>) => {
    setTrigger(true);
  };
  const approvalModal = (e: React.MouseEvent<HTMLButtonElement>) => {
    let vendorData: any = [];
    if (selectedRow.length > 0) {
      selectedRow?.map((item: any) => {
        selectedRow?.map((ele: any, index: any) => {
          if (item.VendorName !== ele.VendorName) {
            vendorData.push(ele.VendorName);
            setSameVendor(true);
          }
        });
      });
      setSameVendorName(vendorData);
      if (
        vendorData.length <= 0 ||
        selectedRow.every(
          (val: any, i: any, arr: any[]) => val.VendorName === arr[0].VendorName
        )
      ) {
        setApproveModal(true);
      }
    }
  };

  useEffect(() => {
    const selectedIds = Object.keys(rowSelection).filter(
      (id) => rowSelection[id]
    );
    const selectedRows = selectedIds.map(
      (index) => filterValues.data[parseInt(index)]
    );
    setSelectedRow(selectedRows);
  }, [rowSelection]);

  const approvehandler = async (approve: boolean) => {
    setLoader(true);
    setApproveModal(false);
    setRejectModal(false);
    const data = {
      idList: selectedRow.map((row: REPLENISHMENT_DATA_TYPE) => row.Id),
      isApproved: approve,
      modifiedBy: userName,
    };
    try {
      const res = await replenishmentApprove(data);
      if (res) {
        setSelectedRow([]);
        showSuccessNotification(res);
        setRowSelection({});
        dispatch(
          fetchReplenishmentList({
            isPendingApprovalOnly,
            vendor: [],
            UserName: userName,
          })
        );
      } else {
        showErrorNotification(res.error.messages);
      }
    } catch (error: any) {
      showErrorNotification(error.response.data.error.messages[0]);
    }
    setLoader(false);
  };
  useEffect(() => {
    dispatch(
      fetchReplenishmentList({
        isPendingApprovalOnly,
        vendor: vendorName ? vendorName : [],
        UserName: userName,
      })
    );
  }, [isPendingApprovalOnly, vendorName]);

  useEffect(() => {
    if (filterValues?.data) {
      setPOSum(handlePOSum());
      setTotalQuantity(handleTotalQuantity());
    }
  }, [filterValues?.data, updateData]);

  useEffect(() => {
    if (filteredData) {
      setPOSum(handlePOSum());
      setTotalQuantity(handleTotalQuantity());
    }
  }, [filteredData]);

  const { data, loading } = useSelector(
    (state: any) => state[`${MODULE_KEY}${ACTION.STATE_KEY}`]
  );

  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});

  const validateRequired = (value: string) => !!value.length;

  const getItemIndex = (
    condition: (item: {
      id: any;
      OverrideOrderQuantity: any;
    }) => boolean
  ): number => {
    return updateData.findIndex(condition);
  };

  const columns = [
    {
      id: "SKU",
      header: "SKU",
      accessorKey: "SKU",
      size: 100,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "FRAME NAME",
      accessorKey: "FrameName",
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      enableEditing: false,
    },
    {
      header: "VENDOR NAME",
      accessorKey: "VendorName",
      size: 135,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "COLLECTION",
      accessorKey: "Collection",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "ORDER ID",
      accessorKey: "OrderID",
      size: 110,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "ORDER QTY",
      accessorKey: "OrderQuantity",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
    },
    {
      header: "OVERRIDE ORDER QUANTITY",
      accessorKey: "OverrideOrderQuantity",
      size: 150,
      enableColumnFilter: false,
      filterFn: 'contains',
      enableSorting: false,
      editingMode : "cell",
      Cell: ({ cell, row }: { cell: any; row: any }) => {
        const originalValue = row.original?.OverrideOrderQuantity;
        const updatedRow = updateData.find((item: any) => item.Id === row.original.Id);
        const displayValue = updatedRow ? updatedRow.OverrideOrderQuantity : originalValue;

        return displayValue;
      },
      Edit: ({ cell, row }: { cell: any; row: any }) => {
        const [newValue, setNewValue] = useState<number>(
          Number(cell.row?.original?.OverrideOrderQuantity) || 0
        );
        return (
          <input
            type="number"
            min="0"
            value={newValue} 
            onChange={(event: any) => {
              const value = parseFloat(event.target.value);
              setNewValue(value); 
            }}
            onBlur={(event: any) => {
              const value = parseFloat(event.target.value);
              if (isNaN(value) || value < 0) return;
                const index = getItemIndex((item: any) => item.Id === row.original.Id);

                if (index === -1) {
                  setupdateData((prev: any) => [
                    ...prev,
                    {
                      Id: row.original.Id,
                      OverrideOrderQuantity: value,
                    },
                  ]);
                  onSaveChanges(row.original, value, '');
                } else {
                  onSaveChanges(row.original, value, '');
                  setupdateData((prev: any) => {
                    const updatedData = [...prev];
                    updatedData[index].OverrideOrderQuantity = value;
                    return updatedData;
                  });
              }
            }}
          />
        );
      },
    },
    {
      header: "MED COST",
      accessorKey: "UnitCost",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
      Cell: ({ cell }: { cell: any }) => {
        const med = cell.row?.original?.UnitCost;
        return med ? "$" + med : "$0";
      },
    },
    {
      header: "EXT COST",
      accessorKey: "ExtCost",
      size: 120,
      enableColumnFilter: true,
      filterFn: 'contains',
      enableSorting: true,
      enableEditing: false,
      Cell: ({ cell }: { cell: any }) => {
        const med = cell.row?.original?.ExtCost;
        return med ? "$" + med : "$0";
      },
    },
    {
      header: "ONHAND QTY",
      accessorKey: "OnHandQuantity",
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      enableEditing: false,
    },
    {
      header: "BACK ORDER QTY",
      accessorKey: "BackOrderQuantity",
      size: 110,
      enableColumnFilter: false,
      enableSorting: false,
      enableEditing: false,
    },
    {
      header: "MIN QTY",
      accessorKey: "MinQuantity",
      size: 90,
      enableColumnFilter: false,
      enableSorting: false,
      enableEditing: false,
    },
    {
      header: "MAX QTY",
      accessorKey: "MaxQuantity",
      size: 100,
      enableColumnFilter: false,
      enableSorting: false,
      enableEditing: false,
    },
    {
      header: "ORDER DATE",
      accessorKey: "OrderDate",
      size: 120,
      enableColumnFilter: false,
      enableSorting: true,
      enableEditing: false,
      Cell: ({ cell }: { cell: any }) => {
        const OrderDate = cell.row?.original.OrderDate;
        return OrderDate ? formatDate(OrderDate) : "N/A";
      },
    },
    {
      header: "PREV ORDER ID",
      accessorKey: "PreviousOrderId",
      size: 110,
      enableColumnFilter: false,
      enableSorting: false,
      enableEditing: false,
    },
    {
      header: "PREV ORDER DATE",
      accessorKey: "PreviousOrderDate",
      size: 130,
      enableColumnFilter: false,
      enableSorting: true,
      enableEditing: false,
      Cell: ({ cell }: { cell: any }) => {
        const PreviousOrderDate = cell.row?.original.PreviousOrderDate;
        return PreviousOrderDate ? formatDate(PreviousOrderDate) : "N/A";
      },
    },
    {
      header: "APPROVAL STATUS",
      accessorKey: "ApprovalStatus",
      size: 120,
      enableColumnFilter: false,
      enableSorting: false,
      enableEditing: false,
    },
    {
      header: "CREATED DATE",
      accessorKey: "CreatedDate",
      size: 110,
      enableColumnFilter: false,
      enableSorting: true,
      enableEditing: false,
      Cell: ({ cell }: { cell: any }) => {
        const CreatedDate = cell.row?.original.CreatedDate;
        return CreatedDate ? formatDate(CreatedDate) : "N/A";
      },
    },
    {
      header: "MODIFIED DATE",
      accessorKey: "ModifiedDate",
      size: 120,
      enableColumnFilter: false,
      enableSorting: true,
      enableEditing: false,
      Cell: ({ cell }: { cell: any }) => {
        const ModifiedDate = cell.row?.original.ModifiedDate;
        return ModifiedDate ? formatDate(ModifiedDate) : "N/A";
      },
    },
    {
      header: "MODIFIED BY",
      accessorKey: "ModifiedBy",
      size: 110,
      enableColumnFilter: false,
      enableSorting: false,
      enableEditing: false,
    },
  ];

  const handlePOSum = () => {
    let totalSum = 0;
    const data = filteredData?.map?.((row: any) => row.original) ?? filterValues.data;
    data?.map((item: any) => {
      totalSum += item.ExtCost;
    });
    return totalSum;
  };

  const handleTotalQuantity = () => {
    let totalQuantity = 0;
    const data = filteredData?.map?.((row: any) => row.original) ?? filterValues.data;
    data?.map((item: any) => {
      const updatedItem = updateData.find((u: any) => u.Id === item.Id);

      const effectiveItem = {
        ...item,
        ...updatedItem,
      };
      const quantity = parseFloat(effectiveItem.OverrideOrderQuantity) || 0;
      totalQuantity += quantity;
    });

    return totalQuantity;
  };

  const handleRefresh = async () => {
    setLoader(true);
    try {
      const newObj: { VendorName: any }[] = [];
      const vendors =
        vendorName.length > 0 ? vendorName : filterValues.vendorName;
      vendors.map((item: any) => {
        newObj.push({ VendorName: item.value ? item.value : item });
      });
      const res = await replenishmentRefresh({
        VendorList: newObj,
        UserName: userName,
      });
      if (res) {
        showSuccessNotification(res);
        setOpen(false);
        setLoader(false);
        setTrigger(false);
        dispatch(
          fetchReplenishmentList({
            isPendingApprovalOnly,
            vendor: [],
            UserName: userName,
          })
        );
      } else {
        showErrorNotification(res.messages);
        setOpen(false);
        setTrigger(false);
        setLoader(false);
      }
    } catch (error: any) {
      showErrorNotification(error.response.data.error.messages[0]);
      setOpen(false);
      setTrigger(false);
      setLoader(false);
    }
  };

  const exportExcelFile = async () => {
    setLoader(true);
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("DC Replenisment Sheet");
    //sheet.properties.defaultRowHeight = 25;

    sheet.columns = DC_REPLENISHMENT_EXCEL_COLUMN;
    const data = filteredData?.map((row: any) => row.original).length > 0 ? filteredData?.map((row: any) => row.original) : filterValues.data;
    try {
      if (data?.length > 0) {
        setExportFile(false);
        setLoader(false);
        let color;
        const promise = Promise.all(
          data?.map(async (item: any, index: number) => {
            const rowNumber = index + 2;
            sheet.addRow({
              SKU: item.SKU,
              FrameName: item.FrameName,
              VendorName: item.VendorName,
              Collection: item.Collection,
              OrderID: item.OrderID,
              OrderQuantity: item.OrderQuantity,
              OnHandQuantity: item.OnHandQuantity,
              BackOrderQuantity: item.BackOrderQuantity,
              MinQuantity: item.MinQuantity,
              MaxQuantity: item.MaxQuantity,
              OverrideOrderQuantity: item.OverrideOrderQuantity,
              UnitCost: item.UnitCost,
              ExtCost: item.ExtCost,
              OrderDate:
                item.OrderDate !== null
                  ? dayjs(item.OrderDate).format("YYYY-MM-DD")
                  : "",
              PreviousOrderId: item.PreviousOrderId,
              PreviousOrderDate:
                item.PreviousOrderDate !== null
                  ? dayjs(item.PreviousOrderDate).format("YYYY-MM-DD")
                  : "",
              ApprovalStatus: item.ApprovalStatus,
              CreatedDate:
                item.CreatedDate !== null
                  ? dayjs(item.CreatedDate).format("YYYY-MM-DD")
                  : "",
              ModifiedDate:
                item.ModifiedDate !== null
                  ? dayjs(item.ModifiedDate).format("YYYY-MM-DD")
                  : "",
              ModifiedBy: item.ModifiedBy,
            });
          })
        );

        promise.then(() => {
          workbook.xlsx.writeBuffer().then(function (res: BlobPart) {
            const blob = new Blob([res], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement("a");
            anchor.href = url;
            anchor.download = "DC Replenishment-Report.csv";
            anchor.click();
            window.URL.revokeObjectURL(url);
          });
          showSuccessNotification("Excel downloaded successfully");
        });
      } else {
        setExportFile(false);
        setLoader(false);
        showErrorNotification("No data available for the selected date");
      }
    } catch (error: any) {
      setExportFile(false);
      setLoader(false);
      showErrorNotification(error.response.data.error.messages[0]);
    }
  };

  const onSaveChanges = async (record: any, value: any, name: any) => {
    const payload = {
      id: record?.Id,
      OrderQuantity: value,
    };
    updateOrderQty(payload)
      .then((res: any) => {
        showSuccessNotification(res);
        dispatch(
          fetchReplenishmentList({
            isPendingApprovalOnly,
            vendor: [],
            UserName: userName,
          })
        );
      })
      .catch((error: any) => {
        showErrorNotification(error.response.data.error.messages[0]);
      });
  };

  return (
    <Spin spinning={loader}>
      <div>
        <Divider />
        <Breadcrumb>
          <span>Vendor Order</span>
        </Breadcrumb>
        <TableFilter>
          <div className="d-flex gap-2">
            <VendorReplenishment setVendorName={setVendorName} />
            {hasPermission("replenishment_manualtrigger") && (
              <Button
                onClick={triggerModal}
                size="middle"
                disabled={!vendorName.length}
              >
                Manual Trigger
              </Button>
            )}
            <Label
              label={
                "Total PO Sum: " +
                pOSum.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })
              }
              className="flex-row align-items-center fs-6 gap-3"
            >
              <></>
            </Label>
            <Label
              label={"Total Units: " + totalQuantity}
              className="flex-row align-items-center fs-6 gap-3"
            >
              <></>
            </Label>
          </div>
          <div className="d-flex gap-2 justify-content-end">
            <Label
              label="Display Pending Orders only"
              className="flex-row align-items-center fs-6 gap-3"
            >
              <Switch
                size="small"
                checked={isPendingApprovalOnly}
                onChange={(flag) => {
                  setIsPendingApprovalOnly(flag);
                }}
              />
            </Label>
            <Button
              size="middle"
              icon={<DownloadOutlined />}
              ant-click-animating-without-extra-node="true"
              onClick={() => setExportFile(true)}
              disabled={filteredData[0] === "none"}
            >
              {" "}
              Export
            </Button>
            <div>
              {hasPermission("replenishment_refresh") && (
                <Button onClick={closeModal} size="middle">
                  Refresh
                </Button>
              )}
            </div>
            <div>
              {hasPermission("replenishment_approve") && (
                <Button
                  onClick={approvalModal}
                  size="middle"
                  disabled={loader || !selectedRow.length}
                >
                  Approve
                </Button>
              )}
            </div>
            <div>
              {hasPermission("replenishment_reject") && (
                <Button
                  onClick={() => setRejectModal(true)}
                  size="middle"
                  danger={true}
                  disabled={loader || !selectedRow.length}
                >
                  Reject
                </Button>
              )}
            </div>
          </div>
        </TableFilter>

        <GenericGrid
          columns={columns}
          data={data}
          enableRowSelection={true}
          onRowSelectionChange={setRowSelection}
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
          filterDisplayMode="popover"
          highlightFilterMatch={true}
          paginationDisplayMode="pages"
          paginationProps={{
            color: "primary",
            shape: "rounded",
            showRowsPerPage: true,
            variant: "outlined",
            rowsPerPageOptions: [10, 50, 100, 500, 1000],
          }}
          enableStickyHeader={true}
          enableStickyFooter={true}
          enableColumnPinning={true}
          columnPinning={{}}
          isLoading={filterValues.loading}
          filteredData={filteredData}
          setFilteredData={setFilteredData}
          enableEditing={true}
          muiTableBodyCellProps={{
            sx: {
              fontSize: "10px",
              textAlign: "left",
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              fontSize: "10px",
              fontWeight: "800",
              fontFamily:
                '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
              textAlign: "left",
              padding: "5px 10px",
            },
          }}
          muiTableBodyRowProps={{
            sx: {
              "& td": {
                padding: "5px 10px",
              },
            },
          }}
        ></GenericGrid>

        <Modal
          title="Approve Confirmation"
          centered
          confirmLoading={loader}
          open={approveModal}
          onOk={() => approvehandler(true)}
          onCancel={() => setApproveModal(false)}
        >
          <span>
            Are you sure you want to Approve the request and replenish the
            selected items?
          </span>
        </Modal>
        <Modal
          title="Reject Confirmation"
          centered
          confirmLoading={loader}
          open={rejectModal}
          onOk={() => approvehandler(false)}
          onCancel={() => setRejectModal(false)}
        >
          <span>
            Are you sure you want to Reject the request and ignore the selected
            item replenishment?
          </span>
        </Modal>
        <Modal
          title="Refesh Confirmation"
          okText="Ok"
          centered
          confirmLoading={loader}
          style={{ top: 20 }}
          open={open}
          onOk={() => handleRefresh()}
          onCancel={() => setOpen(false)}
        >
          <span>
            Are you sure you want to refesh pending replenisment orders?
          </span>
        </Modal>
        <Modal
          title="Trigger Confirmation"
          okText="Ok"
          centered
          confirmLoading={loader}
          style={{ top: 20 }}
          open={trigger}
          onOk={() => handleRefresh()}
          onCancel={() => setTrigger(false)}
        >
          <span>
            Are you sure you wish to trigger a manual replenishment for the
            selected vendor(s)?
          </span>
        </Modal>
        <Modal
          title="Vendor Confirmation"
          okText="Ok"
          centered
          confirmLoading={loader}
          style={{ top: 20 }}
          open={sameVendor}
          onOk={(e) => setSameVendor(false)}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <span>
            Please ensure all orders are for the same vendor
            <br />
            Vendor Name : {[...new Set(sameVendorName)].join(", ")}
          </span>
        </Modal>
        <Modal
          title="Excel export Confirmation"
          okText="Ok"
          open={exportFile}
          centered
          confirmLoading={loader}
          style={{ top: 20 }}
          onOk={exportExcelFile}
          onCancel={() => setExportFile(false)}
        >
          <span>Are you sure you want to export this data?</span>
        </Modal>
      </div>
    </Spin>
  );
}
const StyledDiv = styled.div`
  color: #fff;
  position: absolute;
  left: 24%;
  font-size: 16px;
`;
export default Replenishment;
